var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chartRef",staticClass:"bar-chart",staticStyle:{"width":"100%","height":"300px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }